import React from "react";
import Text from "../../../../shared/components/Text";
import { formatMoney } from "nemuru-components";

export const HintDownPaymentImportGreaterThanMax = ({ maxAutoDownPayment }) => (
  <>
    <Text>{"DOWN_PAYMENT_OVER"}</Text> {formatMoney(maxAutoDownPayment, 0)}
  </>
);
